function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import VideosCarouselDesktopComponent from "./desktop/videos-carousel-desktop-component";
class VideosCarouselComponent extends PureComponent {
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: "videos-carousel-container",
            children: /*#__PURE__*/ _jsx("div", {
                className: "videos-carousel-desktop-wrapper",
                children: /*#__PURE__*/ _jsx(VideosCarouselDesktopComponent, _object_spread({}, this.props))
            })
        });
    }
}
export { VideosCarouselComponent as default };
VideosCarouselComponent.defaultProps = {
    title: "A new way to manage your <brand-purple>workflow.</end>",
    videos: [
        {
            title: "Nate Travers <brand-blue>Manufactoring</end>",
            videoId: "1UbaEcto56k",
            poster: "/static/img/templates/long-template/segments/boards/board-with-cactus-and-phone.png"
        },
        {
            title: "Aleah Jean Rosales <brand-green>Creative</end>",
            videoId: "1UbaEcto56k",
            poster: "/static/img/templates/long-template/segments/boards/board-with-timeline-and-cactus.png"
        },
        {
            title: "Brad Wohlgemuth <brand-pink>Broadcast</end>",
            videoId: "1UbaEcto56k",
            poster: "/static/img/templates/long-template/segments/boards/board-with-pencils.png"
        }
    ]
};
